import script from "./CountryIt.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CountryIt.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountryIt.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CountryIt.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__